import { PivotBasePlainObject } from './pivotBase.plainObject';

export class PivotPlainObject extends PivotBasePlainObject {
    public pivotKeyColumn: string;
}
